<template>
  <div class="position-relative" id="subheader">
    <b-container>
      <b-row align-v="center" no-gutters>
        <b-col cols="12" class="position-static d-flex align-items-center justify-content-between">
          <!-- Logo -->
          <router-link to="/" class="d-block ">
            <div class="py-3 h-100">
              <img :src="require('@/assets/img/logo/logo-en.svg')" alt="Ennepe-Ruhr-Kreis" class="img img-fluid logo-header" />
            </div>
          </router-link>
          <!-- /Logo -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    LanguageHeader,
  },
})
export default class HeaderInformationNavigationEn extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return 'de';
  }
}
</script>
<style scoped lang="scss">
[theme="default"] {
  #subheader {
    background-color: white !important;
  }
  .logo-header {
    width: 250px;
  }
  .main-nav-item {
    margin: 0 3px 0 0;
  }
  .main-nav-link {
    color: #68726A;
    font-weight: 500;
    background-color: #EEF1F0;
    padding: 5px 15px;
    margin: 5px 0;
    border-radius: 5px;
    transition: none;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
    &:hover, &:active {
      background-color: var(--portal-primary);
      color: #ffffff!important;
    }
  }
  .main-nav-link-btn {
    font-weight: 500;
    padding: 5px 15px;
    margin: 5px 0;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
  }
  .auth-cabinet .logo-header {
    height: auto;
  }
}

.main-nav-list {
  padding: 0.625rem 1.125rem;
  margin: 0 0 1rem;
  background: transparent;
}
.main-nav-link-wrapper {
  >a, >a:visited, >a:active, >a:hover {
    color: rgb(var(--portal-secondary-600));
    text-decoration: none;
  }
}

//sub-nav
.main-nav-item--dropdown,
.main-nav-item--dropdown .main-nav-link-wrapper {
  overflow: visible;
}
ul.main-nav-list li:hover div > ul {
  visibility: visible;
  opacity: 1;
}
ul.main-nav-list ul {
  list-style: none;
  margin: 5px 0 0;
  padding: 10px 0 0;
  visibility: hidden;
  position: absolute;
  z-index: 99999;
  opacity: 0;
  -webkit-transition: opacity 0.2s linear, visibility 0.2s linear;
  -moz-transition: opacity 0.2s linear, visibility 0.2s linear;
  -o-transition: opacity 0.2s linear, visibility 0.2s linear;
  transition: opacity 0.2s linear, visibility 0.2s linear;
  top: 100%;
  left: 0px;
  text-transform: none;
  font-weight: 600;
  line-height: 1.4em;
  -moz-box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  width: 250px;
  overflow: hidden;
  background: var(--portal-primary);
}
ul.main-nav-list ul.quicklinks {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 800px;
  max-width: min(800px, calc(100vw - 24px));
  padding: 12px 20px 16px;
  gap: 5px 40px;
  left: 40%;
  transform: translateX(-40%);
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    width: min(280px, calc(100vw - 24px));
    max-width: min(280px, calc(100vw - 24px));
    left: 50%;
    transform: translateX(-50%);
  }
}

ul.main-nav-list ul li {
  clear: both;
  width: 100%;
  background: none transparent;
}
ul.main-nav-list ul li {
  display: inline;
  float: left;
  margin: 0;
  padding: 0;
  position: relative;
  background-image: none;
  border-radius: 5px;
  margin-right: 2px;
}
ul.main-nav-list ul.quicklinks li {
  float: none;
  display: block;
  margin-right: 0;
  width: auto;
}
ul.main-nav-list ul li a {
  padding: 3px 10px 3px 12px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  display: block;
  border: 0 none;
  clear: both;
  border-radius: 0px;
  background-color: transparent;
}
ul.main-nav-list ul li a:hover,
ul.main-nav-list ul li.active a {
  color: white;
}
ul.main-nav-list ul li:last-child a {
  padding: 3px 10px 12px 12px;
}
ul.main-nav-list ul.quicklinks li a {
  padding: 4px 0;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 14px;
}
ul.main-nav-list ul.quicklinks li:last-child a {
  padding: 4px 0;
}
@media (max-width: 991.98px) {
  .main-nav-item:not(:last-child){
   border-bottom: none;
}
}

@media (max-width: 991.98px) {
  .main-nav-item {
     margin: 0 3px 0 0!important;
    width: inherit;
    padding: 0;
  }
}

</style>
